import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import { View } from 'react-native';
import { useAgapellaAccess } from '../../services/agapellaAccess';
import { showsAgapellaBadge } from '../../services/agapellaGate';
import type { ContentAccess } from '../../types/agapellaSubscription';
import { AccessBadge } from './AccessBadge';

interface Props {
  /** Поле `access` карточки с сервера (CORE-1769/1770). */
  access?: ContentAccess | null;
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

/** Отступ под бейджем на карточке: бейдж стоит над названием. */
export const badgeGap = { marginBottom: 6 } as const;

/**
 * CORE-1777 — бейдж «Входит в Agapēlla» на карточках эфиров, практик и комнат
 * (страница CORE-662, 4.1). Тот же вид, что на программах (CORE-1538). Решает
 * `showsAgapellaBadge`: флаг подписки выключен — бейджа нет, даже если сервер
 * прислал `included`. С подпиской бейдж остаётся — он объясняет, почему это
 * открыто. «Бесплатно» на этих карточках не пишем: всё непомеченное бесплатно.
 */
export const AgapellaBadge: React.FC<Props> = ({ access, style, testID = 'agapella-badge' }) => {
  const state = useAgapellaAccess();
  if (!showsAgapellaBadge({ access }, state)) return null;
  return (
    <View style={style}>
      <AccessBadge price={null} includedInAgapella testID={testID} />
    </View>
  );
};
